import { thunk, action } from 'easy-peasy'

export const VIEW = Object.freeze({
	MOBILE: 'MOBILE',
	LANDSCAPE: 'LANDSCAPE',
})

export default {
	mode: VIEW.LANDSCAPE,
	sortingSectionId: null,
	pageId: null,
	data: {},

	setMode: action(() => {}),

	setSortingSectionId: action(() => {}),

	fetch: thunk(() => {}),
}
